import React from 'react';
import TextExtended from '../../../text-extended/text-extended';
import { st, classes } from './action-sheet-item.st.css';
export const ActionSheetItem = ({ label, onClick, icon: Icon, dataHook, isBlackAndWhite }) => {
    return (React.createElement("div", { "data-hook": dataHook, className: classes.actionItem, onClick: onClick },
        Icon && (React.createElement(Icon, { className: st(classes.actionIcon, { isBlackAndWhite: isBlackAndWhite === true }) })),
        React.createElement(TextExtended, { className: classes.actionLabel, priority: isBlackAndWhite === true ? 'black' : 'primary' }, label)));
};
//# sourceMappingURL=action-sheet-item.js.map